export default attr => {
	if ( attr === 'true' ) {
		return true;
	}

	if ( attr === 'false' ) {
		return false;
	}

	return attr;
};
